/**
 * Color mapping for forge/application statuses used in the diagram.
 * Returns Tailwind-compatible classes for background + border + text.
 */

export type StatusTone = 'success' | 'info' | 'warning' | 'danger' | 'muted';

const STATUS_MAP: Record<string, StatusTone> = {
  deployed: 'success',
  active: 'success',
  running: 'success',
  healthy: 'success',
  creating: 'info',
  initializing: 'info',
  building: 'info',
  deploying: 'info',
  updating: 'info',
  stopped: 'warning',
  unknown: 'muted',
  error: 'danger',
  build_failed: 'danger',
  deleting: 'danger',
  unhealthy: 'danger',
};

export const toneFromStatus = (status?: string | null): StatusTone => {
  if (!status) return 'muted';
  return STATUS_MAP[status.toLowerCase()] || 'muted';
};

export const toneClasses = (tone: StatusTone): { bg: string; border: string; text: string; dot: string } => {
  switch (tone) {
    case 'success':
      return {
        bg: 'bg-emerald-50 dark:bg-emerald-950/30',
        border: 'border-emerald-500',
        text: 'text-emerald-700 dark:text-emerald-300',
        dot: 'bg-emerald-500',
      };
    case 'info':
      return {
        bg: 'bg-sky-50 dark:bg-sky-950/30',
        border: 'border-sky-500',
        text: 'text-sky-700 dark:text-sky-300',
        dot: 'bg-sky-500',
      };
    case 'warning':
      return {
        bg: 'bg-amber-50 dark:bg-amber-950/30',
        border: 'border-amber-500',
        text: 'text-amber-700 dark:text-amber-300',
        dot: 'bg-amber-500',
      };
    case 'danger':
      return {
        bg: 'bg-rose-50 dark:bg-rose-950/30',
        border: 'border-rose-500',
        text: 'text-rose-700 dark:text-rose-300',
        dot: 'bg-rose-500',
      };
    case 'muted':
    default:
      return {
        bg: 'bg-muted/40',
        border: 'border-border',
        text: 'text-muted-foreground',
        dot: 'bg-muted-foreground/60',
      };
  }
};
